import { createContext, } from 'react';
import { initialAppState, } from './appState';
import { initialAuthState, } from './authState';
import { initialProjectsState, } from './projectState';
import { initialProjectAgentsState, } from './projectAgentsState';
import { initialAgentLogsState, } from './agentLogsState';
import { initialUsersState, } from './usersState';
import { initialUserLogsState, } from './userLogsState';
import { initialHomeLogsState, } from './homeLogsState';
import { initialDeviceClassesState, } from './deviceClassesState';
import { initialProjectDevicesState, } from './projectDevicesState';
import { initialDeviceLogsState, } from './deviceLogsState';
import { initialHomesState, } from './homesState';
import { initialMetricsReportSubscriptionsState, } from './metricsReportSubscriptionsState';
import { initialOrganizationsState, } from './organizationsState';
import { initialFirmwareState, } from './firmwareState';
/**
 * Create an instance of RitzDataState and initialize it all the initial states.
 */
export const initialRitzDataState = {
    app: initialAppState,
    auth: initialAuthState,
    projects: initialProjectsState,
    projectAgents: initialProjectAgentsState,
    agentLogs: initialAgentLogsState,
    users: initialUsersState,
    userLogs: initialUserLogsState,
    homes: initialHomesState,
    homeLogs: initialHomeLogsState,
    deviceClasses: initialDeviceClassesState,
    projectDevices: initialProjectDevicesState,
    firmware: initialFirmwareState,
    deviceLogs: initialDeviceLogsState,
    metricsReportSubscriptions: initialMetricsReportSubscriptionsState,
    organizations: initialOrganizationsState,
};
/**
 * An instance of the RitzDataContext. Any Component that are interested in the global data context, can use React's useContext
 * to get a reference to this context like this
 *      const {state, dispatch} = React.useContext(ritzDataContext);
 */
export const ritzDataContext = createContext({
    state: initialRitzDataState,
    dispatch: () => {
        return Promise.resolve();
    },
});
